import clsx from "clsx";
import { twMerge } from "tailwind-merge";
import { CardProps } from "@rumble-it/common-components/components/Card/types";

const Card = ({ className, children }: CardProps) => (
  <div
    className={twMerge(
      clsx(
        "bg-white border border-solid border-neutral-300 rounded-2xl h-fit",
        className,
      ),
    )}
  >
    {children}
  </div>
);

const CardHeader = ({ className, children }: CardProps) => (
  <div
    className={twMerge(
      clsx(
        "px-10 py-5 border-b border-solid border-neutral-200 flex justify-between items-center",
        className,
      ),
    )}
  >
    {children}
  </div>
);

const CardTitle = ({ children }: CardProps) => (
  <h2 className="mr-auto font-bold text-lg">{children}</h2>
);

const CardSubtitle = ({ children }: CardProps) => (
  <h2 className="mr-auto text-neutral-400 text-md">{children}</h2>
);

const CardContent = ({ children, className }: CardProps) => {
  return (
    <div className={twMerge(clsx("px-10 py-5", className))}>{children}</div>
  );
};

const CardContentTable = ({ children }: CardProps) => {
  return <div className="px-4 pt-2 pb-5">{children}</div>;
};

const CardFooter = ({ children }) => {
  return (
    <div className="px-10 py-5 border-t border-solid border-neutral-200 flex">
      {children}
    </div>
  );
};

export {
  Card,
  CardHeader,
  CardTitle,
  CardSubtitle,
  CardContent,
  CardContentTable,
  CardFooter,
};
